import {z} from 'zod';

import i18n from '@dms/i18n';

export const BasicInformationFormDefinitionSchema = z.object({
  sourceWarehouseId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  destinationWarehouseId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  destinationBranchId: z.string().nullish(),
  destinationAuthorizationProfileId: z.string().nullish(),
  note: z.string().nullish(),
});

export type BasicInformationFormDefinition = z.infer<typeof BasicInformationFormDefinitionSchema>;
